import type { HiringTutorPayload } from './interfaces'

import { useApiRoute } from '../routes/api-route.hook'
import { useTrackRequest } from '../track-request.hook'

const EVENT_NAME = 'hiring_tutor_tracking'

interface ReturnHiringApi {
  saveTutorTracking: (payload: HiringTutorPayload) => void
}

export const useHiringApi = (): ReturnHiringApi => {
  const { $axios } = useNuxtApp()
  const runtimeConfig = useRuntimeConfig().public
  const { trackError, trackErrorMessage } = useTrackRequest(EVENT_NAME)

  const API_TOKEN = runtimeConfig.hiringApiToken

  const saveTutorTracking = (payload: HiringTutorPayload): void => {
    const url = useApiRoute('hiring.tutor.tracking')

    if (!url || !API_TOKEN) {
      console.warn('Missing url or token for hiring api')
      trackErrorMessage('Missing url or token for hiring api')
      return
    }

    $axios.post(url, payload).catch(trackError)
  }

  return {
    saveTutorTracking,
  }
}
